<style lang="less" scoped></style>

<template>
  <van-nav-bar
    v-if="showNavbar"
    :title="curTitle"
    safe-area-inset-top
    :style="style"
    :left-arrow="showLeftArrow"
    :border="border"
    :fixed="fixed"
    @click-left="routeBack"
  >
    <template #right>
      <slot name="right" />
    </template>
  </van-nav-bar>
</template>

<script setup lang="ts">
  import { useAppOs } from '@/store';
  import { StyleValue } from 'vue';
  import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

  defineOptions({ name: 'LocalNavbar' });
  const route = useRoute();
  const router = useRouter();
  const appOs = useAppOs();

  const props = withDefaults(
    defineProps<{
      title?: string;
      border?: boolean;
      style?: StyleValue;
      fixed?: boolean;
    }>(),
    { border: true }
  );

  const showNavbar = computed(() => !appOs.osVer || appOs.osVer === 'h5');
  const curTitle = computed(() => {
    const curTitle =
      props.title ||
      (route.meta.title as string | ((data: RouteLocationNormalizedLoadedGeneric) => string)) ||
      '';
    return typeof curTitle === 'function' ? curTitle(route) : curTitle;
  });

  const showLeftArrow = ref(false);

  watch(
    () => route.path,
    () => (showLeftArrow.value = !!window.history.state.back),
    { immediate: true }
  );
  const routeBack = () => {
    router.back();
  };
</script>
